import React, { Component, Fragment } from 'react'
import ContainerWithTitle from '../../HOC/ContainerWithTitle'
import { connect } from 'react-redux'
import { MenuItem, Menu, Drawer, Grid } from '@material-ui/core'
import { openErrorMessage } from '../../../actions/message'
import { SearchBarConnect } from '../../../components/MasterCatalog/SearchBar'
import { MCFilterBar } from '../../../components/MasterCatalog/MCFilterBar'
import FormMasterProduct from '../../../components/MasterCatalog/FormMasterProduct'
import { ModalCreateChildProductLoader } from '../../../components/MasterCatalog/ModalCreateChildProduct'
import {
  AmountComponent,
  StatusComponent,
  ActiveInactiveComponent,
  MCStatusComponent,
  MCProductNameComponent,
  MCImageAssetComponent,
  MCTextComponent,
  MCDataDropdownComponent,
} from '../../../components/MasterCatalog/Components'
import {
  AmountEditor,
  StatusEditor,
  MCStatusEditor,
  MCTextEditor,
  MCDataDropdownEditor,
} from '../../../components/MasterCatalog/Components'
import {
  getListCombineProducts,
  updateArchiveMasterProduct,
  getListVendors,
  unlinkProductsFromParent,
  getListCategories,
  updateSingleMasterProducts,
  getListPriceTemplates,
  getListMemberGroups,
  getListBrands,
  setAdoptionModeMasterProducts,
  getMasterProductWithChilds,
  getListProductTags,
  bulkUpdateChildProducts,
  getMasterProduct,
} from '../../../actions/masterCatalog'

import ModalUpdateMasterProduct from '../../../components/MasterCatalog/ModalUpdateMasterProduct'
import { getShopList } from '../../../actions/shop'
import { getProductNameRenderer } from '../../../components/MasterCatalog/Fields'
import { createFakeServer } from './MasterProductGrouping'
import { cannabisTypeOptionsList, EventEmitter } from '../../../utils/common'
import { updateProperties } from '../../../utils/catalog/masterProduct'
import ConfirmationModal from '../../../components/MasterCatalog/ConfirmationModal'
import { InventoryBatchesModalConnect } from '../../../components/MasterCatalog/Fields/InventoryBatchesModal'

import { productTypes, CHILD_SOURCE, PARENT_SOURCE } from '../../../utils/common'
import { EditableSelect, EditableTextField } from '../../../components/common/EditableComponents'
import AgGrid from '../../../components/ag_grid/AgGrid'
import ModalMcImages from '../../../components/MasterCatalog/Modals/ModalMcImages'
import { getProduct } from '../../../actions/inventory'
import { hideZendesk, showZendesk } from '../../../utils/crm'

import { LinkValue, SameValue } from '../../../assets'
import { isFeatureFlagEnable } from '../../../api/unleash'
import { UnleashToggles } from '../../../types/unleashToggles'
import { getStateCannabisDefinitionActions } from '../../../actions/compliance'
import { getSession } from '../../../utils/api'
import { filter } from 'lodash'

const ITEM_HEIGHT = 48
const PAGINATION_PAGE_SIZE = 20

const cellStyle = {
  borderLeft: '1px solid #EEEEEE !important',
  borderRight: '1px solid #EEEEEE !important',
}

let timeout

class MasterProducts extends Component {
  AUTO_GROUP_COLUMN_NAME = 'Item'

  constructor(props) {
    super(props)
    this.getAllMasterProducts = this.getAllMasterProducts.bind(this)
    this.state = {
      columnDefs: [
        {
          field: 'shop',
          headerName: 'Shop',
          minWidth: 200,
          cellRendererFramework: (props) => {
            return <span>{props.value && props.value.name}</span>
          },
        },
        {
          headerName: 'Inventory',
          minWidth: 150,
          field: 'totalInventory',
        },
        {
          field: 'unitPrice',
          headerName: 'Retail Price',
          cellRenderer: 'AmountComponent',
          cellEditor: 'AmountEditor',
          cellRendererParams: {
            onSyncChildEvent: this.onSyncChildEvent,
          },
          cellEditorParams: {
            min: 0,
            max: 100000,
            precision: 2,
          },
          minWidth: 150,
          editable: true,
        },

        {
          field: 'active',
          dataFieldName: 'enableStatus',
          dataFieldOptions: ['Inactive', 'Active'],
          headerName: 'Status',
          minWidth: 150,
          editable: true,
          cellRenderer: 'MCStatusComponent',
          cellEditor: 'MCStatusEditor',
          cellRendererParams: {
            options: ['Inactive', 'Active'],
            onSyncChildEvent: this.onSyncChildEvent,
          },
          cellEditorParams: {
            options: ['Inactive', 'Active'],
          },
        },
        {
          field: 'sku',
          headerName: 'SKU',
          minWidth: 150,
          cellRenderer: 'MCTextComponent',
          editable: true,
          cellRendererParams: {
            onSyncChildEvent: this.onSyncChildEvent,
          },
        },
        {
          field: 'masterCategoryId',
          headerName: 'Category',
          minWidth: 250,
          editable: false,
          cellRenderer: 'MCDataDropdownComponent',
          cellRendererParams: {
            "childField":"categoryId",
            hideSync: true,
            onSyncChildEvent: this.onSyncChildEvent,
            getDataOptions: this.getCategoriesMap,
          },
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            getDataOptionsList: this.getCategoriesList,
          },
        },
        {
          field: 'categoryName',
          headerName: 'Category',
          minWidth: 150,
          editable: false,
        },
        {
          field: 'brandId',
          headerName: 'Brand',
          minWidth: 250,
          editable: true,
          cellRenderer: 'MCDataDropdownComponent',
          cellRendererParams: {
            onSyncChildEvent: this.onSyncChildEvent,
            getDataOptions: this.getBrandsMap,
          },
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            getDataOptionsList: this.getBrandsDataList,
          },
        },
        {
          field: 'tags',
          headerName: 'Tags',
          minWidth: 300,
          editable: true,
          cellRenderer: 'MCTextComponent',
          cellRendererParams: {
            onSyncChildEvent: this.onSyncChildEvent,
          },
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            dropDownDataType: 'Text',
            multiple: true,
            getDataOptionsList: this.getUniqueueProductList,
          },
        },
        {
          field: 'vendorId',
          headerName: 'Vendor',
          minWidth: 250,
          editable: true,
          cellRenderer: 'MCDataDropdownComponent',
          cellRendererParams: {
            onSyncChildEvent: this.onSyncChildEvent,
            getDataOptions: this.getVendorsMap,
          },
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            getDataOptionsList: this.getVendorsDataList,
          },
        },
        {
          field: 'secondaryVendors',
          headerName: 'Secondary Vendors',
          minWidth: 300,
          editable: true,
          cellRenderer: 'MCDataDropdownComponent',
          cellRendererParams: {
            onSyncChildEvent: this.onSyncChildEvent,
            getDataOptions: this.getVendorsMap,
            multiple: true,
          },
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            getDataOptionsList: this.getVendorsDataList,
            multiple: true,
          },
        },
        {
          field: 'description',
          headerName: 'Description',
          minWidth: 300,
          editable: true,
          cellEditor: 'agLargeTextCellEditor',
          cellRenderer: 'MCTextComponent',
          cellRendererParams: {
            onSyncChildEvent: this.onSyncChildEvent,
          },
        },
        {
          field: 'productType',
          headerName: 'Product Type',
          minWidth: 150,
          editable: true,
          cellRenderer: 'MCDataDropdownComponent',
          cellRendererParams: {
            dropDownDataType: 'LabelValue',
            onSyncChildEvent: this.onSyncChildEvent,
            getDataOptions: this.getProductTypesMap,
          },
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            dropDownDataType: 'LabelValue',
            getDataOptionsList: this.getProductTypesList,
          },
        },
        {
          field: 'cannabisType',
          headerName: 'Cannabis Type',
          minWidth: 150,
          editable: true,
          cellRenderer: 'MCDataDropdownComponent',
          cellRendererParams: {
            dropDownDataType: 'LabelValue',
            onSyncChildEvent: this.onSyncChildEvent,
            getDataOptions: this.getCannabisTypesMap,
          },
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            dropDownDataType: 'LabelValue',
            getDataOptionsList: this.getCannabisTypes,
          },
        },
        {
          field: 'flowerType',
          headerName: 'Flower Type',
          minWidth: 300,
          editable: true,
          cellRenderer: 'MCTextComponent',
          cellRendererParams: {
            onSyncChildEvent: this.onSyncChildEvent,
          },
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            dropDownDataType: 'Text',
            multiple: false,
            getDataOptionsList: this.getFlowerTypes,
          },
        },
        {
          field: 'enableWeedmap',
          headerName: 'Sync to 3rd Party Menus',
          minWidth: 220,
          editable: true,
          cellRenderer: 'MCStatusComponent',
          cellEditor: 'MCStatusEditor',
          cellRendererParams: {
            options: ['No', 'Yes'],
            onSyncChildEvent: this.onSyncChildEvent,
          },
          cellEditorParams: {
            options: ['No', 'Yes'],
          },
        },
        {
          field: 'lowThreshold',
          headerName: 'LIT Threshold',
          dataFieldName: 'lit',
          minWidth: 150,
          editable: true,
          cellEditor: 'AmountEditor',
          cellRenderer: 'AmountComponent',
          cellRendererParams: {
            hideCurrency: true,
            onSyncChildEvent: this.onSyncChildEvent,
          },
        },
        {
          field: 'archived',
          headerName: 'Archived',
          dataFieldName: 'enableArchive',
          dataFieldOptions: ['Unarchive', 'Archived'],
          minWidth: 150,
          editable: true,
          cellRenderer: 'MCStatusComponent',
          cellEditor: 'MCStatusEditor',
          cellRendererParams: {
            options: ['No', 'Yes'],
            onSyncChildEvent: this.onSyncChildEvent,
          },
          cellEditorParams: {
            options: ['No', 'Yes'],
          },
        },
        {
          field: 'assets',
          headerName: 'Images',
          minWidth: 150,
          cellRenderer: 'MCImageAssetComponent',
          cellRendererParams: {
            openColumnModal: this.openColumnModal,
            onSyncChildEvent: this.onSyncChildEvent,
          },
        },
      ],
      fullData: [],
      defaultColDef: {
        flex: 1,
        resizable: true,
        cellStyle: cellStyle,
        headerClass: 'catalog-aggrid-header',
        cellClass: 'catalog-aggrid-cell',
        suppressParentNodeEditing: false,
      },
      autoGroupColumnInitialWidth: 400,
      getRowNodeId: function (params) {
        return params.data.id
      },
      openSideBarMasterProduct: false,
      openMenu: false,
      selectedProduct: null,
      anchorEl: null,
      actionToMasterProducts: [],
      selectedMasterProduct: null,
      selectedParentProduct: null,
      modalProductMaster: false,
      masterProducts: [],
      selectedProductType: '',
      optionToBulkUpdate: null,
      rowModelType: 'serverSide',
      serverSideStoreType: 'partial',
      isServerSideGroupOpenByDefault: function () {
        return false
      },
      isServerSideGroup: function (dataItem) {
        return dataItem.group
      },
      getServerSideGroupKey: function (dataItem) {
        return dataItem.id
      },
      checkActive: false,
      checkInactive: false,
      checkArchived: false,
      filter: ['ACTIVE', 'INACTIVE'],
      term: '',
      openModalToClone: false,
      showModalConfirmation: false,
      key: '',
      modalDetail: {},
      typeProduct: 'master',
      adoptionMode: false,
      numEnterKeyPage: '',

      selectedData: null,
      agGridProps: {},
      flowerTypes: [],
      cannabisTypeList: {},
      cannabisTypeForState: false,
      pageSize: PAGINATION_PAGE_SIZE,
      filterMasterCategoryIds: [],
      filterBrandIds: [],
      filterVendorIds: [],
    }
    this.onGridReady = this.onGridReady.bind(this)
    this.updateMasterProduct = this.updateMasterProduct.bind(this)
    this.dataFormat = this.dataFormat.bind(this)
    this.serverSideDatasource = this.serverSideDatasource.bind(this)
    this.formatterData = this.formatterData.bind(this)
    this.processOnGrid = this.processOnGrid.bind(this)
    this.onPaginationChanged = this.onPaginationChanged.bind(this)
    this.onRowId = this.onRowId.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    const { companyFeatures = {} } = this.props.companyReducer || {}
    if (companyFeatures.enableMasterCatalog != null && !companyFeatures.enableMasterCatalog) {
      return this.props.history.push('/')
    }
  }

  componentWillMount() {
    this.props.dispatch(getListVendors())
    this.props.dispatch(getListBrands())
    this.props.dispatch(getShopList()).then((result) => {
      let flowerTypeSet = new Set()
      result &&
        result.values &&
        result.values.forEach((shop) => {
          if (shop && shop.flowerType) {
            shop.flowerType.forEach((flowerType) => {
              flowerTypeSet.add(flowerType)
            })
          }
        })
      this.setState({ flowerTypes: [...flowerTypeSet] })
    })
    this.props.dispatch(getListCategories()).then(() => {
      this.gridApi.refreshCells({force : true});
    });
    this.props.dispatch(getListPriceTemplates())
    this.props.dispatch(getListMemberGroups())
    this.props.dispatch(getListProductTags())
    EventEmitter.subscribe('updateProductList', () => {
      this.getAllMasterProducts()
    })

    this.props.dispatch(setAdoptionModeMasterProducts(false))
    localStorage.removeItem('ADOPTION_MODE')
    localStorage.removeItem('ADOPTION_MODE_VERIFY')
  }

  componentDidMount() {
    const user = getSession()
    const { company = {} } = user || {}
    isFeatureFlagEnable(UnleashToggles.CANNABIS_TYPE_FOR_STATE).then((res) => {
      if (res) {
        this.props
          .dispatch(getStateCannabisDefinitionActions(company, true))
          .then((cannabisTypeList) => {
            this.setState({
              cannabisTypeList,
              cannabisTypeForState: res,
            })
          })
      }
    })
  }

  getAllMasterProducts = () => {
    this.processOnGrid()
  }

  handleChangeTypeProduct = (value) => {
    this.uncheckAllCheckboxes()

    this.setState(
      {
        typeProduct: value,
        masterProducts: [],
        selectedProductType: '',
        autoGroupColumnDef: {},
      },
      () => {
        this.processOnGrid()
      },
    )
  }

  isFullWidth = (data) => {
    return data.component === 'select'
  }

  openColumnModal = (column, isParent, data, agGridProps) => {
    const { shopReducer } = this.props

    if (isParent) {
      this.props.dispatch(getMasterProductWithChilds(data.id)).then((res) => {
        this.setState({ selectedData: res, agGridProps })
        this.openModalByColumn(column)
      })
    } else {
      this.props.dispatch(getProduct(data.id)).then((res) => {
        const selectedShop =
          shopReducer &&
          shopReducer.shopsList &&
          shopReducer.shopsList.values &&
          shopReducer.shopsList.values.find((shop) => shop.id === res.shopId)
        res.shop = selectedShop
        this.setState({ selectedData: res, agGridProps })
        this.openModalByColumn(column)
      })
    }
  }

  openModalByColumn = (column) => {
    if (column === 'productImages') {
      this.setState({ showModalMcImages: true })
    }
  }

  // Update selected master products
  handleCheck = (check, data) => {
    let result = [...this.state.masterProducts] || []
    const { adoptionMode } = this.props.masterCatalogReducer
    let property = data.children ? 'parent' : !data.masterId ? 'orphan' : 'child'

    if (check.target.checked) {
      if (adoptionMode && property === 'parent') {
        if (result.length > 0) {
          this.setState(
            {
              autoGroupColumnDef: {
                cellRendererParams: {},
              },
            },
            () => {
              this.props.dispatch(
                openErrorMessage('Only one master product can be selected at a time.'),
              )
            },
          )

          return
        }
      }

      result.push(data)
    } else {
      result = result.filter((c) => c.id !== data.id)
    }

    this.setState(
      {
        masterProducts: result,
        selectedProductType: property,
        autoGroupColumnDef: {
          cellRendererParams: {},
        },
      },
      () => {},
    )
  }

  // Define options for the selected product
  handleMenu = (image, data) => {
    let actions = [{ key: 'edit', value: 'Edit' }]

    if (data.children) {
      actions.push({
        key: 'cloneToNewLocation',
        value: 'Clone to new Location',
      });
      actions.push({
        key: 'duplicate',
        value: 'Duplicate',
      })
    } else if (data.masterId) {
      actions.push({
        key: 'pushChildDataToParent',
        value: 'Push Child Data to Parent',
      })
      actions.push({ key: 'makeOrphan', value: 'Make Orphan' })
    }

    this.setState({
      anchorEl: image.currentTarget,
      actionToMasterProducts: actions,
      selectedMasterProduct: data,
    })
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    this.processOnGrid()
  }

  serverSideDatasource = (typeProduct, pageSize, { term = '' }, { filter = "",filterMasterCategoryIds = [], filterBrandIds = [] }) => {
    const $this = this
    return {
      getRows: function (params) {
        if (params.parentNode.data) {
          let server = createFakeServer([params.parentNode.data])
          let response = server.getData(params.request)
          setTimeout(function () {
            params.successCallback(response, response.length)
          }, 500)
        } else {
          $this.props
            .dispatch(
              getListCombineProducts(
                $this.gridApi.paginationGetCurrentPage() * pageSize,
                pageSize,
                term,
                filter,
                '',
                '',
                typeProduct,
                filterMasterCategoryIds,
                filterBrandIds
              ),
            )
            .then((res) => {
              if (res.total > 0) {
                let lastRow = () => {
                  return res.total || -1
                }
                const processData = $this.formatterData(res && res.values)
                let server = createFakeServer(processData)
                let response = server.getData(params.request)
                setTimeout(function () {
                  params.successCallback(response, lastRow())
                }, 200)
                $this.setState({
                  fullData: processData,
                })
              } else {
                params.successCallback([], 0)
              }
            })
        }
      },
    }
  }

  formatterData = (data = []) => {
    let result = []
    data.forEach((product) => {
      let newProduct = product.orphan ? product.orphan : product.master
      result.push(newProduct)
    })
    return result
  }

  processOnGrid = () => {
    const { typeProduct, pageSize, term, filter,filterMasterCategoryIds,filterBrandIds } = this.state
    this.gridApi.setServerSideDatasource(
      this.serverSideDatasource(
        typeProduct,
        pageSize,
        { term: term || '' },
        { filter: (filter || []).join(), 
          filterMasterCategoryIds: filterMasterCategoryIds || [],
          filterBrandIds: filterBrandIds || [],
        },
      ),
    )
  }

  processFilterOnGrid = (filter) => {
    this.processOnGrid()
  }

  collectIds = (data) => {
    return data.map((d) => d.id)
  }

  onFilterTextBoxChanged = (event) => {
    const term = event.target.value
    const { typeProduct = 'master', pageSize } = this.state
    const filter = this.state.filter || []
    const {filterMasterCategoryIds,filterBrandIds} = this.state

    this.setState({ term: term })
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      if (!term) {
        this.gridApi.setServerSideDatasource(
          this.serverSideDatasource(typeProduct, pageSize, { term: '' }, 
            { filter: filter.join(), 
              filterMasterCategoryIds: filterMasterCategoryIds || [],
              filterBrandIds: filterBrandIds || [],
             }),
        )
      }

      if (term) {
        this.setState({
          timeout: setTimeout(() => {
            if (term) {
              this.gridApi.setServerSideDatasource(
                this.serverSideDatasource(
                  typeProduct,
                  pageSize,
                  { term: term },
                  { filter: filter.join(),
                    filterMasterCategoryIds: filterMasterCategoryIds || [],
                    filterBrandIds: filterBrandIds || [],
                  },
                ),
              )
            }
          }, 500),
        })
      }
    }, 1500)
  }

  onFilterSwitchChanged = (state) => {
    const { typeProduct = 'master', pageSize, term } = this.state
    let filterResult = state.map((filter) => filter.value) || []
    this.setState({
      filter: filterResult,
    })
    this.applyFilter()
  }

  applyFilter = () => {
    const { typeProduct = 'master', pageSize, term, filter } = this.state
    this.gridApi.setServerSideDatasource(
      this.serverSideDatasource(
        typeProduct,
        pageSize,
        { term: term },
        { filter: filter.join(),
          filterMasterCategoryIds: this.state.filterMasterCategoryIds || [],
          filterBrandIds: this.state.filterBrandIds || [],
        },
      )
    )
  }

  onRowSelected = (event) => {
    const rows = event.api.getSelectedNodes().map((row) => {
      return row.data
    })
    this.setState({ masterProducts: rows })
  }

  dataFormat = (data) => {
    let newArray = []

    data.forEach((parent) => {
      newArray.push({
        orgHierarchy: [parent.name],
        ...parent,
      })
      parent.children.forEach((child, index) => {
        newArray.push({
          orgHierarchy: [parent.name, child.name + index],
          ...child,
        })
      })
    })
    return newArray
  }

  updateMasterProduct = (key) => {
    switch (key) {
      case 'cloneToNewLocation':
        this.cloneToNewLocation()
        break
      case 'makeOrphan':
        this.makeOrphan()
        break
      case 'edit':
        this.handleClickOpen(false)
        break
      case 'duplicate':
        this.duplicateClickOpen(true)
        break
      case 'pushChildDataToParent':
        this.pushChildDataToParent()
        break
      default:
        break
    }
    this.handleCloseMenu()
  }

  beforeUpdateProduct = (key) => {
    let data = null
    switch (key) {
      case 'cloneToNewLocation':
        this.cloneToNewLocation()
        break
      case 'makeOrphan':
        data = {
          title: 'Unlink from Parent',
          description:
            'Making it an Orphan keeps the Parent values. Updating will make it an Orphan, while not updating will keep as a Child.',
        }
        break
      case 'edit':
        this.updateMasterProduct(key)
        break
      case 'duplicate':
        this.updateMasterProduct(key)
        break
      case 'pushChildDataToParent':
        data = {
          title: 'Update Parent values from selected Child',
          description: 'Updating will replace the parent values with the child values.',
        }
        break
      default:
        break
    }
    if (data) {
      this.setState({
        key,
        modalDetail: data,
        showModalConfirmation: true,
      })
    }
  }

  cloneToNewLocation = () => {
    this.setState({
      openModalToClone: true,
    })
  }

  pushChildDataToParent = () => {
    const { selectedMasterProduct, fullData } = this.state
    const parent = fullData.find((p) => p.id === selectedMasterProduct.masterId)
    const newData = {
      ...parent,
      ...selectedMasterProduct,
      id: parent.id,
      masterCategoryId: parent.masterCategoryId,
      categoryId: null,
      category: null,
      masterId: null,
    }
    this.props.dispatch(updateSingleMasterProducts(newData)).then(() => {
      this.getAllMasterProducts()
    })
  }

  makeOrphan = () => {
    const { selectedMasterProduct } = this.state
    this.props.dispatch(unlinkProductsFromParent(selectedMasterProduct.id)).then(() => {
      this.props.dispatch(getMasterProductWithChilds(selectedMasterProduct.masterId)).then((mp) => {
        const shopsSelected =
          (mp.shopIds && mp.shopIds.filter((shopId) => shopId !== selectedMasterProduct.shopId)) ||
          []
        if (mp.children && mp.children.length == 0) {
          const data = {
            masterProductId: selectedMasterProduct.masterId,
            isArchived: true,
          }
          this.props.dispatch(updateArchiveMasterProduct(data)).then(() => {
            const newData = {
              ...mp,
              archived: true,
              shopIds: shopsSelected,
            }
            this.props.dispatch(updateSingleMasterProducts(newData))
            timeout = setTimeout(() => {
              this.getAllMasterProducts()
              clearTimeout(timeout)
            }, 3000)
          })
        } else {
          const newData = { ...mp, shopIds: shopsSelected }
          this.props.dispatch(updateSingleMasterProducts(newData)).then(() => {
            this.getAllMasterProducts()
          })
        }
      })
    })
  }

  updateArchiveMasterProduct = () => {
    const { selectedMasterProduct } = this.state
    const data = {
      masterProductId: selectedMasterProduct.id,
      isArchived: !selectedMasterProduct.archived,
    }
    this.props.dispatch(updateArchiveMasterProduct(data)).then((response) => {
      this.getAllMasterProducts()
    })
  }

  handleClickOpen = (create = true) => {
    hideZendesk()
    if (create) {
      this.setState({
        selectedMasterProduct: null,
      })
    }
    this.setState({ duplicate:false,openSideBarMasterProduct: true })
  }

  duplicateClickOpen = () => {
    hideZendesk()
    this.setState({
      duplicate:true,
      openSideBarMasterProduct: true })
  }

  handleClose = (update = false) => {
    showZendesk()
    this.setState({
      duplicate:false,
      openSideBarMasterProduct: false,
      selectedMasterProduct: null,
    })
    if (update === true) {
      this.gridApi.deselectAll()
      this.getAllMasterProducts()
    }
  }

  handleCloseMenu = () => {
    this.setState({ anchorEl: null })
    this.closeConfirmationModal()
  }

  bulkUpdate = (option) => {
    this.setState({
      modalProductMaster: true,
      optionToBulkUpdate: option,
    })
  }

  handleCloseModalProductMaster = (update) => {
    this.setState({
      modalProductMaster: false,
    })
    if (update === true) {
      this.setState(
        {
          masterProducts: [],
          optionToBulkUpdate: null,
        },
        () => {
          this.gridApi.deselectAll()
        },
      )
      this.getAllMasterProducts()
    }
  }

  handleCloseModalToClone = (update = false) => {
    this.setState({
      openModalToClone: false,
      selectedMasterProduct: null,
    })
    if (update === true) {
      this.gridApi.deselectAll()
      this.getAllMasterProducts()
    }
  }

  //Reset column group
  handleAdoptionMode = () => {
    const { masterProducts, selectedProductType, adoptionMode } = this.state

    this.setState({
      adoptionMode: adoptionMode,
      autoGroupColumnDef: {
        cellRendererParams: {},
      },
    })
  }

  handleDeactivateAdoptionMode = () => {
    this.setState({
      selectedParentProduct: null,
      typeProduct: 'master',
      adoptionMode: false,
      autoGroupColumnDef: {
        cellRenderer: 'MCProductNameComponent',
        cellRendererParams: {
          menuEvent: this.handleMenu,
          checkEvent: this.handleCheck,
          adoptionMode: false,
          selectedProducts: [],
        },
      },
      masterProducts: [],
      selectedProductType: '',
    })
    localStorage.removeItem('ADOPTION_MODE')
    localStorage.removeItem('ADOPTION_MODE_VERIFY')
  }

  handleCloseEverything = (update) => {
    this.handleDeactivateAdoptionMode()

    if (this.state.typeProduct == 'master') {
      this.handleChangeTypeProduct('master')
    } else {
      this.handleChangeTypeProduct('orphan')
    }

    if (update) {
      this.gridApi.deselectAll()
      this.getAllMasterProducts()
    }
    this.setState({
      selectedParentProduct: null,
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      key: '',
      modalDetail: {},
      showModalConfirmation: false,
    })
  }

  onPaginationChanged() {
    if (this.gridApi) {
      let totalPages = this.gridApi.paginationGetTotalPages()
      let currentPage = this.gridApi.paginationGetCurrentPage() + 1
      let totalRows = this.gridApi.paginationGetRowCount()
      let pageSize = this.gridApi.paginationGetPageSize()
      let fromRow = this.gridApi.paginationGetCurrentPage() * pageSize + 1
      let toRow = (this.gridApi.paginationGetCurrentPage() + 1) * pageSize
      toRow = toRow > totalRows ? totalRows : toRow

      this.setText('#ag-445-of-page-number', totalPages)
      this.setText('#ag-445-start-page-number', currentPage)
      this.setText('#ag-445-first-row', fromRow)
      this.setText('#ag-445-last-row', toRow)
      this.setText('#ag-445-row-count', totalRows)

      this.setButtonDisabled('#btFirst', currentPage <= 1)
      this.setButtonDisabled('#btPrevious', currentPage <= 1)
      this.setButtonDisabled('#btNext', totalPages == currentPage)
      this.setButtonDisabled('#btLast', totalPages == currentPage)
    }
  }

  onSyncChildEvent = (params, state) => {
    const { icon } = state
    const { data } = params
    const isParent = !!data.children
    if (icon === LinkValue || icon === SameValue) return

    if (!isParent) {
      const parentValue = params.node.parent.data[params.colDef.field]
      params.data[params.colDef.field] = parentValue

      this.updateChildrenProducts([data.id], params, true, true)
    }
  }

  getUpdatedSourceMap = (params, isChild) => {
    if (!isChild) return null

    let sourceDef = CHILD_SOURCE
    const parent = params.node.parent
    const field = params.colDef.field
    if (parent && parent.data && params.data[field] === parent.data[field]) {
      params.data.sourceMap[field] = PARENT_SOURCE
      sourceDef = PARENT_SOURCE
    }

    return {
      [field]: sourceDef,
    }
  }

  onRowId = (data) => {
    return data.id || null
  }

  updateRowData = (params) => {
    const { data, colDef } = params
    const isParent = !!data.children

    if (isParent) {
      this.props.dispatch(getMasterProduct(data.id)).then((origMasterProduct) => {
        let newData = {
          ...origMasterProduct,
          [colDef.field]: params.newValue,
        }

        this.props
          .dispatch(updateSingleMasterProducts(newData))
          .then((res) => {
            if (data.children && data.children.length > 0) {
              const productIds = data.children
                .filter((child) => child.sourceMap[colDef.field] === PARENT_SOURCE)
                .map((c) => c.id)

              if (productIds.length > 0) {
                const newValue = colDef.field === 'sku' ? res.sku : params.newValue

                this.updateChildrenProducts(productIds, params, false, false)
                  .then(() => {
                    this.updateChildrenRows(params, false, newValue)
                  })
                  .catch((err) => {
                    const bulkOption = updateProperties.find((b) => b.field === colDef.field)
                    if (bulkOption) {
                      const sourceMapField = bulkOption.bulkField || bulkOption.field

                      const failedRequest = {
                        childProductIds: productIds,
                        sourceMap: {
                          [sourceMapField]: CHILD_SOURCE,
                        },
                        updateSourceMap: false,
                        partialUpdateSourceMap: true,
                        updateOnlySourceMap: true,
                      }

                      this.props.dispatch(bulkUpdateChildProducts(failedRequest)).then(() => {
                        this.updateChildrenRows(params, true, null)
                      })
                    }
                  })
              }
            }
          })
          .catch((err) => {
            params.node.setData({ ...params.data, [colDef.field]: origMasterProduct.sku })
          })
      })
    } else {
      this.updateChildrenProducts([data.id], params, true, false)
    }
  }

  updateChildrenRows = (params, unlinkField, newValue) => {
    const { data, colDef } = params
    const parentNode = this.gridApi.getRowNode(params.node.id)

    for (const [cIndex, childData] of data.children.entries()) {
      const sourceDef =
        (childData.sourceMap && childData.sourceMap[params.colDef.field]) || CHILD_SOURCE
      if (sourceDef == PARENT_SOURCE) {
        const childRow = params.api.getRowNode(`${parentNode.key}-${cIndex}`)
        if (childRow) {
          if (unlinkField) {
            childData.sourceMap[params.colDef.field] = CHILD_SOURCE
          } else {
            childData[colDef.field] = newValue
          }

          childRow.setData(childData)
        }
      }
    }
  }

  updateChildrenProducts = (productIds = [], params, manualUpdate, linkToParent) => {
    return new Promise((resolve, reject) => {
      const { data, colDef } = params
      const { field } = colDef

      if (linkToParent && params.node.parent) {
        params.data[field] = params.node.parent.data[field]
      }

      const bulkOption = updateProperties.find((b) => b.field === field)
      if (bulkOption) {
        const value = colDef.dataFieldOptions
          ? colDef.dataFieldOptions[params.data[field] ? 1 : 0]
          : params.data[field]

        const updatedSourceMap = manualUpdate
          ? this.getUpdatedSourceMap(params, !!data.masterId)
          : null

        const sourceMapField = bulkOption.bulkField || bulkOption.field

        const request = {
          childProductIds: productIds,
          updateSourceMap: false,
          partialUpdateSourceMap: updatedSourceMap != null,
          sourceMap: updatedSourceMap,
          bulkType: bulkOption.bulkType,
          [sourceMapField]: value,
        }

        this.props
          .dispatch(bulkUpdateChildProducts(request))
          .then((res) => {
            if (manualUpdate) {
              params.data.sourceMap[params.colDef.field] =
                updatedSourceMap != null ? updatedSourceMap[bulkOption.field] : CHILD_SOURCE

              if (field === 'sku') {
                this.props.dispatch(getProduct(productIds[0])).then((res) => {
                  params.node.setData({ ...params.data, sku: res.sku })
                })
              } else {
                params.node.setData({ ...params.data, [bulkOption.field]: value })
              }
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      }
    })
  }

  getLabelValueMap = (listItems) => {
    const itemsMap = {}
    listItems.forEach((t) => {
      itemsMap[t.value] = t
    })
    return itemsMap
  }

  getVendorsMap = () => {
    return this.props.masterCatalogReducer.vendorsMap
  }

  getVendorsDataList = () => {
    return this.props.masterCatalogReducer.vendors
  }

  getBrandsMap = () => {
    return this.props.masterCatalogReducer.brandsMap
  }

  getBrandsDataList = () => {
    return this.props.masterCatalogReducer.brands
  }

  getProductTypesList = () => {
    return productTypes
  }

  getFlowerTypes = () => {
    return this.state.flowerTypes
  }

  getCategoriesList = () => {
    return this.props.masterCatalogReducer.categories
  }

  getCategoriesMap = () => {
    return this.props.masterCatalogReducer.categoriesMap
  }

  getProductTypesMap = () => {
    const productTypeMaps = {}
    productTypes.forEach((t) => {
      productTypeMaps[t.value] = t
    })
    return productTypeMaps
  }

  getProductTypesMap = () => {
    const productTypeMaps = {}
    productTypes.forEach((t) => {
      productTypeMaps[t.value] = t
    })
    return productTypeMaps
  }

  getCannabisTypes = () => {
    return cannabisTypeOptionsList
  }

  getCannabisTypesMap = () => {
    var cannabisTypesMap = this.getLabelValueMap(cannabisTypeOptionsList)
    cannabisTypesMap['DEFAULT'].label = 'Inherit from Category'
    return cannabisTypesMap
  }

  getUniqueueProductList = () => {
    return this.props.masterCatalogReducer.allProductTags
  }

  setText(selector, text) {
    document.querySelector(selector).innerHTML = text
  }

  setButtonDisabled(selector, disabled) {
    let classDisable = 'ag-disabled'

    if (disabled) {
      document.querySelector(selector).classList.add(classDisable)
    } else {
      document.querySelector(selector).classList.remove(classDisable)
    }
  }

  onBtFirst() {
    this.gridApi.paginationGoToFirstPage()
  }

  onBtLast() {
    this.gridApi.paginationGoToLastPage()
  }

  onBtNext() {
    this.gridApi.paginationGoToNextPage()
  }

  onBtPrevious() {
    this.gridApi.paginationGoToPreviousPage()
  }

  onBtNumberPage(page) {
    let numPage = parseInt(page || 0) - 1
    this.gridApi.paginationGoToPage(numPage)
  }

  onBtNumberPageChange(event) {
    this.setState({
      numEnterKeyPage: event.target.value || '',
    })
  }

  onBtNumberPageKeyDown(event) {
    const { numEnterKeyPage } = this.state

    if (event.key === 'Enter') {
      this.onBtNumberPage(numEnterKeyPage || '')
    }
  }

  handlePageSize = (event) => {
    const newPageSize = event.target.value
    this.setState({
      pageSize: newPageSize,
      numEnterKeyPage: '',
    })
    this.gridApi.paginationSetPageSize(Number(newPageSize))
    this.gridApi.gridOptionsWrapper.gridOptions.cacheBlockSize = Number(newPageSize)

    const { typeProduct, term, filter,filterMasterCategoryIds,filterBrandIds } = this.state
    this.gridApi.setServerSideDatasource(
      this.serverSideDatasource(
        typeProduct,
        newPageSize,
        { term: term || '' },
        { filter: (filter || []).join(),
          filterMasterCategoryIds: filterMasterCategoryIds || [],
          filterBrandIds: filterBrandIds || [],
         },
      ),
    )
  }

  uncheckAllCheckboxes() {
    var checkboxes = document.querySelectorAll('.check-name')
    for (var checkbox of checkboxes) {
      checkbox.checked = false
    }
  }

  saveParentProduct = (parent) => {
    this.setState({
      selectedParentProduct: parent,
      autoGroupColumnDef: {
        cellRendererParams: {
          innerRenderer: getProductNameRenderer(),
          checkEvent: this.handleCheck,
          menuEvent: this.handleMenu,
          adoptionMode: true,
          selectedProducts: this.state.masterProducts,
          property: 'orphan',
        },
      },
    })
  }

  render() {
    const {
      columnDefs,
      checkActive,
      checkInactive,
      checkArchived,
      openSideBarMasterProduct,
      anchorEl,
      actionToMasterProducts,
      modalProductMaster,
      masterProducts,
      optionToBulkUpdate,
      selectedMasterProduct,
      openModalToClone,
      showModalConfirmation,
      key,
      modalDetail,
      term,
      typeProduct,
      adoptionMode,
      selectedProductType,
      filter,
      selectedData,
      agGridProps,
      showModalMcImages,
      cannabisTypeList,
      cannabisTypeForState,
    } = this.state
    const { shopsList = {} } = this.props.shopReducer
    const open = Boolean(anchorEl)
      // Remove Category
    columnDefs.map((col) => {
        if (col.field === 'categoryName') {
          col.hide = typeProduct === 'master'
        }
        if (col.field === 'masterCategoryId') {
          col.hide = typeProduct === 'orphan'
        }
    })
    return (
      <React.Fragment>
        <Grid container>
          <Grid item xs={12}>
            <SearchBarConnect
              checkActive={checkActive}
              checkInactive={checkInactive}
              checkArchived={checkArchived}
              saveParentProduct={this.saveParentProduct}
              handleFilterChange={this.onFilterSwitchChanged}
              buttonText={'New Product'}
              openModal={this.handleClickOpen}
              bulkUpdate={this.bulkUpdate}
              handleTermChange={this.onFilterTextBoxChanged}
              filter={filter}
              handleAdoptionMode={this.handleAdoptionMode}
              deactivateAdoptionMode={this.handleDeactivateAdoptionMode}
              selectedProducts={masterProducts}
              onProductTypeChange={this.handleChangeTypeProduct}
              closeEverything={this.handleCloseEverything}
              processOnGrid={this.processFilterOnGrid}
              term={term}
              selectedProductType={selectedProductType}
              selectedParentProduct={this.state.selectedParentProduct}
              typeProduct={typeProduct}
            />
          </Grid>
          <Grid item xs={12} container>
            <Grid className="labelField" item xs={6} sm={6} md={6} lg={2}>
              <p>
                {(masterProducts && masterProducts.length) || 0} {selectedProductType} products
                selected
              </p>
            </Grid>
            {!adoptionMode && (
              <Grid className="editField" item xs={4} sm={4} md={2}>
                <EditableSelect
                  style={{ width: '20%' }}
                  name="type"
                  value={typeProduct}
                  valueToRender={typeProduct}
                  onChange={(e) => this.handleChangeTypeProduct(e.target.value)}
                  material={false}
                  editMode={true}
                >
                  <MenuItem value="master">Master Products</MenuItem>
                  <MenuItem value="orphan">Orphan Products</MenuItem>
                </EditableSelect>
              </Grid>
            )}
            <MCFilterBar 
              onHandleBrandChange={(e)=>this.setState({filterBrandIds:this.collectIds(e)})} 
              onHandleCategoryChange={(e) => this.setState({filterMasterCategoryIds:this.collectIds(e)})}
              onApplyClick={()=>this.applyFilter()}/>
          </Grid>
          <Grid item xs={12} container>
            <Grid item xs={12}>
              <div
                id="master-products-table"
                className="ag-theme-alpine container-aggrid"
                style={{ height: '65vh', marginBottom: '50px' }}
              >
                <AgGrid
                  columnDefs={columnDefs.map((col) => ({ ...col, obj: 'PRODUCT' }))}
                  defaultColDef={this.state.defaultColDef}
                  autoGroupColumnDef={{
                    field: 'name',
                    headerName: this.AUTO_GROUP_COLUMN_NAME,
                    minWidth: 250,
                    pinned: true,
                    suppressMovable: true,
                    initialWidth: this.state.autoGroupColumnInitialWidth,
                    cellRendererParams: {
                      suppressCount: true,
                      innerRenderer: 'MCProductNameComponent',
                      menuEvent: this.handleMenu,
                      checkEvent: this.handleCheck,
                      adoptionMode: false,
                      selectedProducts: [],
                      refreshStrategy: 'rows',
                      checkbox: true,
                    },
                  }}
                  frameworkComponents={{
                    InventoryBatchesModalConnect,
                    AmountComponent,
                    StatusComponent,
                    ActiveInactiveComponent,
                    MCStatusComponent,
                    MCProductNameComponent,
                    MCImageAssetComponent,
                    MCTextComponent,
                    MCDataDropdownComponent,
                    MCStatusEditor,
                    StatusEditor,
                    AmountEditor,
                    MCTextEditor,
                    MCDataDropdownEditor,
                  }}
                  treeData={true}
                  sideBar={{
                    toolPanels: [
                      {
                        id: 'columns',
                        labelDefault: 'Columns',
                        labelKey: 'columns',
                        iconKey: 'columns',
                        toolPanel: 'agColumnsToolPanel',
                        toolPanelParams: {
                          suppressPivots: true,
                          suppressPivotMode: true,
                        },
                      },
                    ],
                  }}
                  animateRows={true}
                  onGridReady={this.onGridReady}
                  rowModelType={this.state.rowModelType}
                  rowHeight={50}
                  pagination={true}
                  paginationPageSize={this.state.pageSize}
                  cacheBlockSize={this.state.pageSize}
                  maxBlocksInCache={1}
                  serverSideStoreType={this.state.serverSideStoreType}
                  isServerSideGroupOpenByDefault={this.state.isServerSideGroupOpenByDefault}
                  isServerSideGroup={this.state.isServerSideGroup}
                  getServerSideGroupKey={this.state.getServerSideGroupKey}
                  onRowSelected={this.onRowSelected}
                  onPaginationChanged={this.onPaginationChanged}
                  onCellValueChanged={this.updateRowData}
                  groupDefaultExpanded={-1}
                  rowBuffer={5}
                  enableGroupEdit={true}
                  rowSelection={'multiple'}
                  suppressRowClickSelection={true}
                />
                <div
                  className="ag-paging-panel ag-unselectable"
                  style={{ justifyContent: 'space-between' }}
                  id="ag-445"
                  aria-live="polite"
                  aria-describedby="ag-445-start-page ag-445-start-page-number ag-445-of-page ag-445-of-page-number ag-445-first-row ag-445-to ag-445-last-row ag-445-of ag-445-row-count"
                >
                  <PageSizeSelector gridApi={this.gridApi} handleChange={this.handlePageSize} />

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span
                      className="ag-paging-row-summary-panel"
                      style={{ marginRight: '10px' }}
                      aria-hidden="true"
                    >
                      <span
                        id="ag-445-first-row"
                        ref="lbFirstRowOnPage"
                        className="ag-paging-row-summary-panel-number"
                      >
                        0
                      </span>
                      <span id="ag-445-to"> to </span>
                      <span
                        id="ag-445-last-row"
                        ref="lbLastRowOnPage"
                        className="ag-paging-row-summary-panel-number"
                      >
                        0
                      </span>
                      <span id="ag-445-of"> of </span>
                      <span
                        id="ag-445-row-count"
                        ref="lbRecordCount"
                        className="ag-paging-row-summary-panel-number"
                      >
                        0
                      </span>
                    </span>

                    <EditableTextField
                      value={this.state.numEnterKeyPage || ''}
                      valueToRender={this.state.numEnterKeyPage || ''}
                      placeholder={'Page'}
                      editMode={true}
                      material={false}
                      style={{ maxWidth: '5em', margin: 'unset' }}
                      onChange={(e) => this.onBtNumberPageChange(e)}
                      onKeyDown={(e) => this.onBtNumberPageKeyDown(e)}
                    />
                  </div>

                  <span className="ag-paging-page-summary-panel" role="presentation">
                    <div
                      id="btFirst"
                      ref="btFirst"
                      className="ag-paging-button ag-disabled"
                      role="button"
                      aria-label="First Page"
                      tabindex="0"
                      aria-disabled="true"
                    >
                      <span
                        className="ag-icon ag-icon-first"
                        unselectable="on"
                        role="presentation"
                        onClick={() => this.onBtFirst()}
                      ></span>
                    </div>
                    <div
                      id="btPrevious"
                      ref="btPrevious"
                      className="ag-paging-button ag-disabled"
                      role="button"
                      aria-label="Previous Page"
                      tabindex="0"
                      aria-disabled="true"
                    >
                      <span
                        className="ag-icon ag-icon-previous"
                        unselectable="on"
                        role="presentation"
                        onClick={() => this.onBtPrevious()}
                      ></span>
                    </div>
                    <span className="ag-paging-description" aria-hidden="true">
                      <span id="ag-445-start-page">Page </span>
                      <span
                        id="ag-445-start-page-number"
                        ref="lbCurrent"
                        className="ag-paging-number"
                      >
                        0
                      </span>
                      <span id="ag-445-of-page"> of </span>
                      <span id="ag-445-of-page-number" ref="lbTotal" className="ag-paging-number">
                        0
                      </span>
                    </span>
                    <div
                      id="btNext"
                      ref="btNext"
                      className="ag-paging-button"
                      role="button"
                      aria-label="Next Page"
                      tabindex="0"
                      aria-disabled="false"
                    >
                      <span
                        className="ag-icon ag-icon-next"
                        unselectable="on"
                        role="presentation"
                        onClick={() => this.onBtNext()}
                      ></span>
                    </div>
                    <div
                      id="btLast"
                      ref="btLast"
                      className="ag-paging-button"
                      role="button"
                      aria-label="Last Page"
                      tabindex="0"
                      aria-disabled="false"
                    >
                      <span
                        className="ag-icon ag-icon-last"
                        unselectable="on"
                        role="presentation"
                        onClick={() => this.onBtLast()}
                      ></span>
                    </div>
                  </span>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
        {openSideBarMasterProduct && (
          <Drawer anchor="right" open={openSideBarMasterProduct}>
            <FormMasterProduct
              handleClose={this.handleClose}
              product={selectedMasterProduct}
              shops={shopsList && shopsList.values}
              cannabisTypeList={cannabisTypeList}
              cannabisTypeForState={cannabisTypeForState}
              duplicate={this.state.duplicate}
            />
          </Drawer>
        )}
        {open && (
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={this.handleCloseMenu}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                minWidth: 200,
              },
            }}
          >
            {actionToMasterProducts.map((option) => (
              <MenuItem key={option.key} onClick={() => this.beforeUpdateProduct(option.key)}>
                {option.value}
              </MenuItem>
            ))}
          </Menu>
        )}

        {modalProductMaster && (
          <ModalUpdateMasterProduct
            open={modalProductMaster}
            handleClose={this.handleCloseModalProductMaster}
            masterProducts={masterProducts}
            optionToBulkUpdate={optionToBulkUpdate}
          />
        )}

        {selectedMasterProduct && (
          <ModalCreateChildProductLoader
            open={openModalToClone}
            product={selectedMasterProduct}
            handleCloseModalToClone={this.handleCloseModalToClone}
          />
        )}

        {showModalConfirmation && (
          <ConfirmationModal
            open={showModalConfirmation}
            keyOption={key}
            close={this.closeConfirmationModal}
            {...modalDetail}
            handleContinue={this.updateMasterProduct}
          />
        )}
        {showModalMcImages && (
          <ModalMcImages
            {...agGridProps}
            dispatch={this.props.dispatch}
            open={showModalMcImages}
            onClose={() => {
              this.setState({ showModalMcImages: false, selectedData: null })
            }}
            isParent={(selectedData && !!selectedData.children) || false}
            data={selectedData}
          />
        )}
      </React.Fragment>
    )
  }
}

class PageSizeSelector extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pageSize: PAGINATION_PAGE_SIZE,
    }
  }

  handleChange = (event) => {
    const pageSize = event.target.value
    this.setState({ pageSize })
    this.props.handleChange(event)
  }

  render() {
    const pageSizes = [20, 60, 100, 200]
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ marginRight: '10px' }}>Entries: </span>
        <EditableSelect
          style={{ maxWidth: '80px' }}
          name="type"
          value={this.state.pageSize}
          onChange={this.handleChange}
          material={false}
          editMode={true}
        >
          {pageSizes.map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </EditableSelect>
      </div>
    )
  }
}

const MasterProductWithTitle = ContainerWithTitle(MasterProducts, 'Master Products')
const MasterProductConnected = connect(
  ({ dispatch, shopReducer, masterCatalogReducer, companyReducer }) => ({
    dispatch,
    shopReducer,
    masterCatalogReducer,
    companyReducer,
  }),
)(MasterProductWithTitle)

export default MasterProductConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/MasterCatalog/MasterProducts.js